import { SupportDocumentationData } from "../access/supportDocumentation/types";
import { File } from "./file";

export class SupportDocumentation {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  file: File;

  constructor(params: SupportDocumentationData) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.title = params.title;
    this.file = new File(params.file);
  }
}
